module.exports = __webpack_public_path__ + "static/github-d160ace5798527574789e89ec034e8f7.png";